import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { UrlParamsPipe } from '../../utilities/url-params.pipe';

@Component({
  selector: 'app-common-international-business',
  templateUrl: './international-business.component.html',
  imports: [CommonModule, UrlParamsPipe],
})
export class CommonInternationalBusinessComponent implements OnInit {
  @Input() IBData: any;
  @Input() insideContainer: any;
  internationalPanelData: any;
  queryParams: any;
  constructor(
    private route: ActivatedRoute
  ) {
    this.subscriptions = [];
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }

  subscriptions: Subscription[];
  ngOnInit(): void {
    this.internationalPanelData = this.IBData;
  }
  ngOnChanges(): void {
    this.internationalPanelData = this.IBData;
  }
  getBackgroundColor(item: any, index: any): any {
    const colors = ['#FDECDF', '#FBDDE2', '#D7ECF0', '#FDF7CE'];
    return colors[index % colors.length]; // Cycles through colors
  }
  getClass(index: any): any {
    const classes = ['orange-200', 'pink-200', 'moonstone-200', 'yellow-200'];
    return classes[index];
  }
}
